// extracted by mini-css-extract-plugin
export default {"categoryContainer":"Categories_categoryContainer__cyDY2","categoryInner":"Categories_categoryInner__rdzLH","role":"Categories_role__M7ffc"};